import axios from 'axios';

const BASE_URL = 'https://api.ymoghar.engineer/api_v1.0';

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add JWT token to outgoing requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            config.headers.Accept = 'application/json';
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor to handle authentication errors (401 Unauthorized, 403 Forbidden)
api.interceptors.response.use(
    (response) => {
        // If the response is successful, just return it
        return response;
    },
    (error) => {
        // Handle authentication errors
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // Clear the authentication token from localStorage
            localStorage.removeItem('token');

            // Log out the user and redirect to the login page.
            // This direct manipulation of window.location is a common approach in
            // standalone interceptors, though in complex React apps, dispatching an
            // action or using a router history object might be preferred.
            // We check if 'window' is defined to ensure this code runs only in a browser environment.
            if (typeof window !== 'undefined') {
                // It's crucial to adjust '/login' if your application's login route is different.
                window.location.href = '/login';
            }
        }

        // Reject the promise with the error. This allows the original caller
        // of the API request to also catch and handle the error (e.g., display a message).
        return Promise.reject(error);
    }
);

export default api;